import {MBMemberInput} from '../../Atoms/MBMemberInput'
import React from 'react'
import {MailMagazine} from '../../../DTO/MailMagazineDTO'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {MBContentNoteWithMarkTypography} from '../../Atoms/Typographies'
import {PIMCard} from '../../Atoms/Cards/PIMCard'

type Props = {
  title: string
  mailMagazineList: MailMagazine[]
  mailMagazineIdCheckedList: number[]
  onChange: (checkedIdList: number[]) => void
}

export function MailMagazineSelectContentBlock(props: Props): JSX.Element {
  return (
    <PIMCard
      headerProps={{title: props.title}}
      testId={'block-mail-magazine'}
    >
      <PIMStack spacing={'10px'}>
        {props.mailMagazineList.map((mailMagazine, i) => {
            const mailMagazineChecked: boolean =
              props.mailMagazineIdCheckedList.includes(mailMagazine.id)
            return (
              <label key={i}>
                <MBMemberInput
                  type="checkbox"
                  className="form-check_01"
                  hasError={false}
                  checked={mailMagazineChecked}
                  onChange={(): void => {
                    props.onChange(
                      switchMailMagazineIdChecked(
                        mailMagazine.id,
                        props.mailMagazineIdCheckedList,
                      ),
                    )
                  }}
                />
                <span className={'txt'}>
                  {mailMagazine.name}
                </span>
              </label>
            )
          },
        )}
        <MBContentNoteWithMarkTypography
          note={'希望しない場合はチェックを外してください'}
        />
      </PIMStack>
    </PIMCard>
  )
}

const switchMailMagazineIdChecked = (
  mailMagazineId: number,
  mailMagazineIdCheckedList: number[],
): number[] => {
  if (!mailMagazineIdCheckedList.includes(mailMagazineId)) {
    return [...mailMagazineIdCheckedList, mailMagazineId]
  } else {
    return mailMagazineIdCheckedList.filter((id) => {
      return id !== mailMagazineId
    })
  }
}
